import { useState, useEffect } from "react";
import moment from "moment";

/**
 * To track time changes.
 * @param {number} timeInterval - Time interval, in milliseconds, to update the current timestamp value
 * @param {boolean} shouldUpdate - Whether the current timestamp should update at regular intervals
 * @returns {number} - Current time in ms
 */
export default function useCurrentTime(timeInterval, shouldUpdate) {
  const [currentTime, setCurrentTime] = useState(() => moment().valueOf());

  useEffect(() => {
    // If we should not update, ensure no interval is scheduled.
    if (!shouldUpdate) return;

    // Immediately update when resuming so consumers don't show stale data.
    setCurrentTime(moment().valueOf());

    const intervalId = setInterval(() => {
      setCurrentTime(moment().valueOf());
    }, timeInterval);

    return () => {
      clearInterval(intervalId);
    };
  }, [timeInterval, shouldUpdate]);

  return currentTime;
}
